export const projects = state => state.projects.items
export const projectsTotal = state => state.projects.total
export const projectById = state => id => _.find(projects(state), {id: parseInt(id)})
export const projectsByCompanyId = state => id => _.filter(projects(state), {company_id: id})
export const contactProjectsByContactId = state => contact_id => {
    contact_id = parseInt(contact_id)
    return _.filter(projects(state), {contact_id})
}
export const projectNameById = state => id => {
    let project = projectById(state)(parseInt(id))
    if (!project) return ''
    let name = project.name ? project.name : '',
        building = project.building ? project.building : '',
        street = project.street ? project.street : ''

    return `#${project.id} ${name} ${building} ${street}`
}
export const projectNumberById = state => id => {
    let project = projectById(state)(parseInt(id))
    return project ? project.id : ''
}
export const projectsByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let project = projectById(state)(id)
        if (project) res.push(project)
        return res
    }, [])
}
export const currentProjectId = state => state.projects.currentProjectId
export const currentProject = state => _.find(state.projects.items, {id: state.projects.currentProjectId})

export const projectStatusById = state => id => {
    let statuses = {
        21: 'Open',
        36: 'Closed'
    }
    return statuses[id]
}

export const projectLocEmailMessage = state => `Hello [contact.full_name],<br><br>
I am following up to see if construction is complete for this project, and if you're ready for sign-off. If so, we can prepare the required paperwork. If not, please let me know when you expect to be ready for sign-off.`
